"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserConsentsTabContent = void 0;
var React = require("react");
var Consents_1 = require("components/Consents");
require("./index.scss");
var UserConsentsTabContent = function (props) {
    var handleAcceptMarketingConsentChange = function (value) {
        return props.onChange(__assign(__assign({}, props.consents), { marketing: value }));
    };
    return (React.createElement("div", { className: "user-consents-tab" },
        React.createElement(Consents_1.Consents, { canAcceptMarketingConsent: true, hasAcceptedMarketingConsent: !!props.consents.marketing, hasAcceptedPrivacyPolicy: !!props.consents.privacyPolicy, hasAcceptedTermsAndConditions: !!props.consents.termsAndConditions, onAcceptMarketingConsentChange: handleAcceptMarketingConsentChange })));
};
exports.UserConsentsTabContent = UserConsentsTabContent;
